import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import { RecoveryRequestType } from 'app/utils/services/types/recovery.type';

const recoveryService = async (data: { data: RecoveryRequestType; url: string }): Promise<any> => {
  try {
    const result = await httpClient.post<any>(data.url, data.data);

    return result;
  } catch (err: any) {
    if (err?.response.status === 400) {
      return err?.response.data;
    }
  }
};

export const useRecoveryService = () => {
  const {
    isLoading: isLoadingRecovery,
    data: dataRecovery,
    mutate: recoveryMutation,
  } = useMutation(['recovery'], (data: { data: RecoveryRequestType; url: string }) => recoveryService(data));

  return { isLoadingRecovery, dataRecovery, recoveryMutation };
};
